export enum JobPostSteps {
  HowIssueReported,
  UploadReceivedEmail,
  AddIssueDetails,
  VerifyDetails,
  AdditionalDetails,
  AssignTrade,
  JobPreview,
  jobEdit,
  JobClone,
}

export enum IssueReportedType {
  FromEmail = 1,
  FromCall = 2,
  InvoiceOnly = 3,
  AIJobPosting = 4
}

export enum JobPostPreviewDrawers {
  None,
  PropertyEdit,
  ServiceTypeEdit,
  TenantDetailsEdit,
}

export enum MaintenanceType {
  Paid = 0,
  Warranty = 1,
}

export enum JobRecurranceType {
  None = 0,
  Daily = 1,
  Weekly = 7,
  Fortnightly = 14,
  Monthly = 30,
  Quarterly = 90,
  SemiAnnually = 180,
  Annually = 365,
  Seasonal = 400,
  TwoYearly = 730,
  Custom = 999,
}

export enum JobRecurranceCustomType {
  None = 0,
  OneWeek = 1,
  TwoWeeks = 2,
  ThreeWeeks = 3,
  FourWeeks = 4,
  FiveWeeks = 5,
  SixWeeks = 6,
  SevenWeeks = 7,
  EightWeeks = 8,
  NineWeeks = 9,
  TenWeeks = 10,
}

export enum JobPriority {
  Emergency = -1,
  Urgent = 1,
  Normal = 2,
}

export const JobPriorityTextMapping: Record<JobPriority, string> = {
  [JobPriority.Emergency]: 'Emergency',
  [JobPriority.Urgent]: 'Urgent',
  [JobPriority.Normal]: 'Non-urgent',
};

export enum PropertyKeyCollectType {
  ContactTenant = 3, //1
  CollectFromOfficeAndEnter = 1, //2
  CollectFromOfficeAndInformTenant = 2, //3
  Custom = 5
}

export enum StrataPropertyKeyCollectType {
  ContactTenant = 3, //1
  CollectFromOfficeAndEnter = 1, //2
  CollectFromOfficeAndInformTenant = 2, //3
  AccessThroughSafeKey = 4, //4
}

export enum TargetTradeOption {
  QuoteRequest = 1,
  WorkOrder = 2,
  OnDemand = 4,
  External = 6,
}

export enum PayerTypeEnum {
  NONE = 0,
  TENANT = 1,
  OWNER = 2,
  MANAGER = 3,
  EXTERNAL = 4,
}

export enum JobBudgetOptions {
  UnSure = 0,
  Under500 = 1,
  Between500N1000 = 2,
  Between1000N2000 = 3,
  Between2000N5000 = 4,
  Over5000 = 5,
  CustomizedUnder = 6,
  Estimate = 7,
  Custom = -999,
}

export enum JobUrgencyOptions {
  None = 0,
  Emergency = -1,
  Urgently = 1,
  BeforeTheWeekend = 2,
  ThisWeekend = 3,
  Other = -999,
}

export enum JobPostMode {
  Post,
  Clone,
}

export enum OutboundPartnerIdType {
  None = 0,
  HiPages = 1,
  HomeEr = 2
}
export enum AIMaintenanceType {
  
  Warranty = 0,
  Paid = 1,
}
